import { Component, inject } from '@angular/core';
import { UserLoginDTO, UserLoginReadByUserIdRequestDTO, UserLoginUpdateRequestDTO } from '../../userlogin.interface';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { UserLoginService } from '../../userlogin.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-crm-reset-password',
  templateUrl: './crm-reset-password.component.html',
  styleUrls: ['../crm-auth-shared.css','./crm-reset-password.component.css']
})
export class CrmResetPasswordComponent {
  userId!: number;
  userData!: UserLoginDTO;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userLoginService = inject(UserLoginService);
  private toastr = inject(ToastrService);
  private routerSub!: Subscription;

  newPassword = '';
  confirmPassword = '';

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.userId = Number(params.get('id'));
      if (this.userId) {
        this.getUserLogin();
      }
    });

    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        localStorage.removeItem('access_token');
      }
    });

    this.toastr.warning(
      'Your password has expired. Please set a new password.',
      'Password Expired'
    );
  }

  ngOnDestroy(): void {
    localStorage.removeItem('access_token');
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  getUserLogin(): void {
    const data: UserLoginReadByUserIdRequestDTO = {
      userId: this.userId,
    };

    this.userLoginService.UserLogin_ReadByUserId(data).subscribe((res) => {
      this.userData = res;
      if (res.status !== 'Expired') {
        this.router.navigate(['/']);
      }
    });
  }

  updatePassword(): void {
    if (!this.newPassword || !this.confirmPassword) return;

    if (this.newPassword !== this.confirmPassword) {
      this.toastr.error(
        'Your new password and confirmation do not match. Please check and try again.',
        'Password Mismatch'
      );
      return;
    }

    const data: UserLoginUpdateRequestDTO = {
      loginId: this.userData.loginId,
      userId: this.userData.userId,
      userName: this.userData.userName,
      userPassword: this.newPassword,
      isActive: 1,
      status: 'Active',
      actionUser: this.userData.userId.toString(),
    };

    this.userLoginService.UserLogin_Update(data).subscribe({
      next: () => {
        this.toastr.success(
          'Please login with your new password.',
          'Password changed successfully!'
        );
        localStorage.removeItem('access_token');
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 2000);
      },
      error: () => {
        this.toastr.error(
          'Something went wrong while resetting your password.',
          'Error'
        );
      },
    });
  }

  redirectToSignUp(): void {
    localStorage.removeItem('access_token');
    this.router.navigate(['/signup']);
  }
}
